import claimed from '../../../assets/claimed.png';
function MintRequestedCertificate({ image }) {
    return <img className="w-full rounded-lg h-full" src={image} alt="claimed-card" />;
}

export default MintRequestedCertificate;
